import React from "react";
import HomeCharts from "./HomeCharts";
import Optimization from "./Optimization";
import EnergyStatus from "./EnergyStatus";
import OccupantsState from "./OccupantsState";
import TodayStats from "./TodayStats";
import Weather from "./Weather";
import EventsList from "./EventsList";
const Home = () => {
    return (
        <div id="index_content" className="right_col" role="main">
            <header className="page-heading">
                <div>
                    <p className="eyebrow">ENERGY CONTROL CENTER</p>
                    <h1>Home energy overview</h1>
                    <p>Live production, consumption and connected-home status from the Domus laboratory.</p>
                </div>
            </header>

            <div className="row top_tiles">
                <div id="place_for_optimization">
                    <Optimization />
                </div> 
                <div id="place_for_energyState">
                    <EnergyStatus />
                </div>
                <div id="place_for_occupantsState">
                    <OccupantsState />
                </div>
            </div>

            <div id="place_for_selfconsumptionChart" className="home-charts-section">
                <HomeCharts />
            </div>
            
            <div id="place_for_todayStats">
                <TodayStats />
            </div>

            <div className="home-secondary-grid">
                <div>
                    <Weather />
                </div>

                <div id="place_for_events">
                    <EventsList />
                </div>  
            </div>
        </div>
    );
};

export default Home;
